let reduceMotionSetting = false;

export function setReduceMotionSetting(on: boolean) {
  reduceMotionSetting = on;
}

export function systemPrefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function prefersReducedMotion() {
  return reduceMotionSetting || systemPrefersReducedMotion();
}

export function motionDuration(ms: number) {
  return prefersReducedMotion() ? 0 : ms;
}

export function reducedTiming(options?: number | KeyframeAnimationOptions): KeyframeAnimationOptions {
  const timing = typeof options === 'number' ? {} : (options ?? {});
  return { ...timing, duration: 0, delay: 0, endDelay: 0, iterations: 1 };
}

// Patched once rather than at each of the app's many animate() calls, so new code is covered too
export function reduceWebAnimations() {
  const animate = Element.prototype.animate;
  Element.prototype.animate = function (keyframes, options) {
    return animate.call(this, keyframes, prefersReducedMotion() ? reducedTiming(options) : options);
  };
}
